exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.account-container[data-v-5ee83e6a] {\n  position: relative;\n}\n.wrapper[data-v-5ee83e6a] {\n  position: absolute;\n  top: 0;\n  width: 100vw;\n  padding-top: 63px;\n}\n", "", {"version":3,"sources":["/home/runner/work/online-store/online-store/src/components/account/Account.vue"],"names":[],"mappings":";AAAA;EACE,mBAAmB;CAAE;AAEvB;EACE,mBAAmB;EACnB,OAAO;EACP,aAAa;EACb,kBAAkB;CAAE","file":"Account.vue","sourcesContent":[".account-container {\n  position: relative; }\n\n.wrapper {\n  position: absolute;\n  top: 0;\n  width: 100vw;\n  padding-top: 63px; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ee83e6a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/account/Account.vue
// module id = U8QS
// module chunks = 18